var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Karanteenissa Omistajana")]),_c('p',[_vm._v("\n        hirvee omistajaflex, outfit ainaki 10 000 e\n    ")])])}]

export { render, staticRenderFns }